
import { useEffect, useState } from 'preact/hooks'


// shares localStotage state between multiple preact apps/portals

const subscriptions = {}

const get = (key) => JSON.parse(window.localStorage.getItem(key) || 'null') || null
const set = (key, value) => {
	window.localStorage.setItem(key, JSON.stringify(value))
	;(subscriptions[key] || []).map(fn => fn(value))
}
const subscribe = (key, fn) => {
	if (!subscriptions[key]) subscriptions[key] = []
	subscriptions[key].push(fn)
}
const unsubscribe = (key, fn) => {
	if (!subscriptions[key]) return
	subscriptions[key] = subscriptions[key].filter(sub => sub !== fn)
}


export function useLocalStorage(key, defaultValue) {
	const val = get(key)
	const [data, setData] = useState(val !== null ? val : defaultValue)

	const onChange = value => setData(value)
	const remove = () => window.localStorage.removeItem(key)
	
	useEffect(() => {
		subscribe(key, onChange)
		return () => unsubscribe(key, onChange)
	}, [])

	useEffect(() => {
		set(key, data)
	}, [data])

	return [data, setData, remove]
}